import classNames from 'classnames';
import { PropsWithChildren } from 'react';

interface TooltipTableRowProps {
  label: string;
  value: string | number;
  className?: string;
  maxContentWidth?: number;
}

const TooltipTableRow = ({ label, value, className, maxContentWidth }: TooltipTableRowProps) => (
  <tr className={classNames('border-t border-t-neutral-400 pb-4', className)}>
    <td className="py-1">{label}</td>
    <td
      className="py-1 pl-1 text-right font-semibold"
      style={{ ...(maxContentWidth ? { maxWidth: `${maxContentWidth}px` } : undefined) }}
    >
      {value}
    </td>
  </tr>
);

interface TooltipTableProps extends PropsWithChildren {
  title: string;
  className?: string;
}

const TooltipTable = ({ title, className, children }: TooltipTableProps) => (
  <table className={classNames('', className)}>
    <thead>
      <tr>
        <th colSpan={2}>{title}</th>
      </tr>
    </thead>
    <tbody>{children}</tbody>
  </table>
);

TooltipTable.Row = TooltipTableRow;

export default TooltipTable;
